import { runInAction } from 'mobx';
import { logger } from '../../../../utils/logger';
import { nonEmptyStringValidator } from '../../../../utils/validators/string';
import { getOrderItems } from '../../selectors/items/get-order-items';
import { getOrderSelections } from '../../selectors/order/get-order-selections';
export const removeOrderItem = (id) => {
    const orderSelections = getOrderSelections();
    const orderItems = getOrderItems();
    if (!nonEmptyStringValidator(id, logger.error, 'id')) {
        throw new Error('Cannot remove order item. Provided id is invalid.');
    }
    if (!orderItems.find(item => item.id === id)) {
        logger.debug(`Cannot find order item to remove with id: ${id}.`);
        return;
    }
    runInAction(() => {
        orderSelections.items = orderItems.filter(item => item.id !== id);
    });
};
